export const loginUser = async (email, password) => {
  try {
    const res = await fetch(process.env.REACT_APP_API_URL + "/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
      credentials: "include",
    });

    const data = await res.json();

    if (res.ok) {
      if (data.user.publishingMessageShown == false) {
        localStorage.setItem("showPublishingMessage", true);
      }

      if (data.user.showBillingDetailsWarning != false) {
        localStorage.setItem("showBillingDetailsWarning", true);
      }

      localStorage.setItem(
        "initials",
        `${data.user.firstName.charAt(0)}.${data.user.lastName.charAt(0)}.`
      );
      return data.user;
    } else {
      throw new Error(data.error);
    }
  } catch (error) {
    console.error("Login error:", error);
    return null;
  }
};

export const checkLogin = async () => {
  try {
    const res = await fetch(process.env.REACT_APP_API_URL + "/api/auth/me", {
      credentials: "include",
    });

    const data = await res.json();

    if (data) {
      return data.user;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const logout = async () => {
  const res = await fetch(process.env.REACT_APP_API_URL + "/api/auth/logout", {
    credentials: "include",
  });

  localStorage.removeItem("showPublishingMessage");
  localStorage.removeItem("showBillingDetailsWarning");
  localStorage.removeItem("initials");
  localStorage.removeItem("firstName");

  window.location.href = "/ienakt";
};

export const registerUser = async (
  legalStatus,
  firstName,
  lastName,
  phone,
  email,
  password,
  receiveNotifications
) => {
  try {
    const res = await fetch(
      process.env.REACT_APP_API_URL + "/api/auth/register",
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          legalStatus,
          firstName,
          lastName,
          phone,
          email,
          password,
          receiveNotifications,
        }),
      }
    );

    const data = await res.json();

    if (res.ok) {
      return data; // Assuming the response will contain a success message or user data
    } else {
      throw new Error(data.message ? data.message : data.error);
    }
  } catch (error) {
    console.error("Registration error:", error);
    throw error;
  }
};

export const requestPasswordReset = async (email) => {
  try {
    const res = await fetch(
      process.env.REACT_APP_API_URL + "/api/auth/password_reset_request",
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      }
    );

    const data = await res.json();

    if (res.ok) {
      return data;
    } else {
      throw new Error(data.error);
    }
  } catch (error) {
    console.error("Login error:", error);
    return null;
  }
};

export const setNewPassword = async (newPassword, resetToken) => {
  try {
    const res = await fetch(
      process.env.REACT_APP_API_URL + "/api/auth/password_update_request",
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ newPassword, resetToken }),
      }
    );

    const data = await res.json();

    if (res.ok) {
      return data;
    } else {
      throw new Error(data.error);
    }
  } catch (error) {
    console.error("Reset error:", error);
    return null;
  }
};
